<template>
  <!-- <div v-if="is_buy==1 && msg !== ''">
    <p class="center fixed isbuymsg">{{ msg }}</p>
  </div> -->
  <div class="detail-tabbar fixed r l" ref="detailTabbar" >

    <div class="flex between size12 C888">
      <div class="detail-tabbar-l flex">
        <div @click="handleTs">
          <img src="@/assets/img/icon16-1.png" />
          <p class="size12">投诉</p>
        </div>
        <div class="detail-tabbar-l-mid" @click="handleCollect">
          <img :src="isCollect === 1?require('@/assets/img/icon26-1.png'):require('@/assets/img/icon26.png')" />
          <p class="size12" :class="{'active': (isCollect === 1)}">收藏</p>
        </div>
        <div @click="handleKf">
          <img src="@/assets/img/icon18.png" />
          <p class="size12">客服</p>
        </div>
      </div>
      <div class="detail-tabbar-r flex">
        <div class="flex" v-if="info.auction_status == 0">
          <div class=" flex">
          <div class="count size14">
            ￥ <input class="price_num" type="number" @change="handleInput" :value="price" min="0">
          </div>
          <div class="add size25 Cfff ml3" @click="handleAdd">+</div>
        </div>
        <button class="submit ml8" v-if="info.auction_type == 3"  @click="submit">提交资料</button>
        <button class="ml8 cj" @click="submit" v-else>出价</button>
        </div>
        
        <div v-else-if="info.auction_status == 1" class="msg C000">等待卖家确认</div>
        <div v-else-if="info.auction_status == 2" class="msg C000">商品已流拍</div>
        <div v-else-if="info.auction_status == 3" class=" C000 size14">{{ info.gainer_name }}以<span class="size16 Cred">￥{{ info.result_price }}</span>中标</div>
      </div>
    </div>
  </div>
  <!-- <p class="center tabartip fixed r l" v-if="is_buy===0">{{ msg }}</p> -->
  <!-- 查看出价资格 -->
  <van-popup v-model:show="showAuction" style="min-height:50%" position="bottom">
   <div class="flex between pad10 ">
    <p></p>
    <div class="size18 bold">提交资料</div>
    <van-icon @click="showAuction = false" name="cross" size="22" />
   </div>
   <div class="pad10">
    <p class="weight mb30">请根据卖家要求提供个人介绍资料</p>
    <van-uploader :after-read="afterRead" v-model="fileList" multiple />
    <van-button round block type="primary" @click="submit">提交资料</van-button>
    <div class="bottom" :style="{ height: detailTabbarHeight + 'px' }"></div>
   </div>

  </van-popup>
</template>
<script>
import ajax from "@/utils/request.js";
import { showToast, showConfirmDialog } from "vant";
export default {
  data () {
    return {
      price:0,
      info:{},
      fileList: [],
      showAuction:false,
      detailTabbarHeight: 0,
    }
  },
  props: {
    is_buy: {
      type: Number,
      default: 0
    },
    msg: {
      type: String,
      default: ""
    },
    goods_id: {
      type: Number
    },
    isCollect: {
      type: Number,
      default: 0
    },
    is_concept: {
      type: Number,
      default: 0
    },
    max_price: {
      type: Number,
      default: 0
    },
    
  },
  emits: ['handleCollect','afterSubmit'],
  watch:{
    goods_id:function(newVal){
      if(newVal){
        this.init()
      }
    },
   
  },
  created(){
    this.init()
  },
  mounted() {
    this.calculateHeight(); // 在组件加载后计算高度
  },
  methods: {
    calculateHeight() {
      // 使用 $refs 获取detail-tabbar的实际高度
      this.detailTabbarHeight = this.$refs.detailTabbar.offsetHeight;
    },
    
    // 出价或提交信息
    submit(){

      if(this.showAuction || this.info.auction_type !== 3){
        const data = {
          goods_id:this.goods_id,
          price:this.price,
          personal_data:[]
        };
        //批量提交图片
        if (this.fileList.length > 0) {
          const uploadPromises = this.fileList.map((item) => {
            return ajax.post("api/dyuploadimg", { file: item.file })
              .then((res) => {
                data.personal_data.push(res.data.url);
              });
          });

          // 使用 Promise.all 等待所有图片上传操作完成
          Promise.all(uploadPromises)
            .then(() => {
              ajax.post("products/submitbid", data)
                .then((res) => {
                    showToast(res.message);
                  this.fileList = []
                  this.showAuction = false
                  this.$emit('afterSubmit')
                });
            })
            .catch((error) => {
              console.error("图片上传失败:", error);
              // 处理图片上传失败的情况
            });
        } else {
          ajax.post("products/submitbid", data)
            .then((res) => {
                showToast(res.message);
              this.fileList = []
              this.showAuction = false
              this.$emit('afterSubmit')
            });
        }
      }else{
        this.showAuction = true
      }

        
    },
    init(){
      ajax.post("products/getauction", {goods_id:this.goods_id}).then(res=>{
        this.info = res.data
        if(this.info.auction_type == 1){
          this.price = this.max_price
        }else{
          this.price = parseFloat(this.info.starting_price).toFixed(2);
        }
        this.price = parseFloat(this.price.replace(/,/g, ''))
      })
    },
    handleInput(event) {
      const inputValue = parseFloat(event.target.value);
      if (this.info.auction_type === 1 && inputValue < this.max_price) {
        showToast('出价不合规\n请重新出价')
        this.price = this.max_price
        
      } else if (inputValue < this.info.starting_price) {
        this.price = this.info.starting_price
      }else{
        this.price = parseFloat(inputValue).toFixed(2)
      }
    },
    handleAdd(){
        this.price = (parseFloat(this.price) + parseFloat(this.info.raise_price)).toFixed(2);
      
    },
    handleTs () {
      if (!localStorage.getItem('loginInfo')) {
        showConfirmDialog({
          title: '是否登录'
        })
          .then(() => {
            // on confirm
            this.$router.push({ path: "/login" })
          }).catch(() => {
            return false
          });

      } else {

        this.$router.push({ path: '/shop/feedback', query: { title: '投诉', goods_id: this.goods_id, type: 1 } })

      }
    },
    handleKf () {

      if (!localStorage.getItem('loginInfo')) {
        showConfirmDialog({
          title: '是否登录'
        })
          .then(() => {
            // on confirm
            this.$router.push({ path: "/login" })
          }).catch(() => {
            return false
          });

      } else {
        if (this.is_concept === 0) {
          // showToast({
          //   message: '观念不匹配',
          // })
          this.$router.push({ path: '/shop/sense', query: { cate_id: 0 } })
          return
        }
        this.$router.push({ path: '/shop/feedback', query: { title: '客服', goods_id: this.goods_id, type: 2 } })
      }
    },
    handleCollect () {
      // products/collect
      const collect = this.isCollect === 0 ? 1 : 2;
      const data = {
        typeid: collect,
        id: this.goods_id
      }
      ajax.post("products/collect", data).then(res => {
        if (res.errcode === 1) {
          const val = this.isCollect === 0 ? 1 : 0
          this.$emit('handleCollect', val)
          showToast(res.message)
        }
      })
    }
  },
}
</script>
<style scoped lang="scss">
.active {
  color: #3F7C93;
}
.detail-tabbar {
  bottom: 0;
  padding: 2.4vw 4vw 3.2vw 5.6vw;
  box-shadow: 0px -1px 20px 0px rgba(0, 0, 0, 0.08);
  background-color: #fff;
  z-index: 9999;
  .detail-tabbar-l {
    img {
      display: block;
      width: 5.3333vw;
      margin: 0 auto;
    }
    .detail-tabbar-l-mid {
        margin-left: 6.4vw;
        margin-right: 6.4vw;
    }
    p {
        text-align: center;
    }
  }
  .detail-tabbar-r {
    justify-content: flex-end;
    button {
      width: 20vw;
      border-radius: 6vw;
      font-size: 14px;
      padding: 2.6667vw 0;
      box-sizing: border-box;
      // &:first-child {
      //   border: 3px solid #E30000;
      //   color: #E30000;
      //   background-color: #fff;
      // }
      // &:last-child {
      //   border: 3px solid #E30000;
      //   background-color: #E30000;
      //   color: #fff;
      //   margin-left: 2.6667vw;
      // }
    }
    .cj{
      border: 3px solid #E30000;
      background-color: #E30000;
      color: #fff;
    }
    .submit{
      border: 3px solid #3F7C93;
      background-color: #3F7C93;
      color: #fff;
    }
    .price_num{
      width: 15vw;
    }
    .count{
      display: flex;
      justify-content: center;
      width: 24vw;
      padding: 1.6vw 0 ;
      color: #3F7C93;
      border: 3px solid #3F7C93;
      border-radius: 8vw;
    }
    .add{
      width: 6vw;
      height: 6vw;
      text-align: center;
      line-height: 6vw;
      background-color: #3F7C93;
      border-radius: 50%;
    }
    .msg{
      width: 50vw;
      text-align: center;
      font-size:18px;
      padding: 2.5vw 0;
    }
  }
}
.tabartip {
    bottom: 0;
    height: 42px;
    line-height: 42px;
    background: rgba(0, 0, 0, 0.4);
    color: #fff;
    font-size: 14px;
    z-index: 99;
  }
  .isbuymsg {
    left: 0;
    right: 0;
    bottom: 64px;
    height: 42px;
    line-height: 42px;
    background: rgba(0, 0, 0, 0.4);
    color: #fff;
    font-size: 14px;
  }
</style>